import { NgModule} from '@angular/core';
import { BrowserModule} from '@angular/platform-browser';
import { BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { CommonModule } from '@angular/common';
//import { HttpModule, Http } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MaterialModule} from '@angular/material';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgSelectModule } from '@ng-select/ng-select';
// import { TourNgBootstrapModule } from 'ngx-tour-ng-bootstrap';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
// import { TranslateModule, TranslateLoader, TranslateStaticLoader } from 'ng2-translate/ng2-translate';
import 'hammerjs'; 

import { AppComponent} from './app.component';
import { AppRoutes} from "./app-routing.module";
import { Interceptor } from './app.interceptor';
import { MainComponent }   from './components/main/main.component';
import { AuthComponent } from './components/auth/auth.component';

import { MenuToggleModule } from './helpers/menu/menu-toggle.module';
import { MenuItems } from './helpers/menu/menu-items/menu-items';
import { PageTitleService } from './helpers/page-title/page-title.service';

import { AuthenticationService } from './components/auth/authentication.service';
import { TokenService } from './components/auth/token.service';
import { MessageService } from './helpers/message.service'; // mensajes
import { GeneralService } from './helpers/general.service'; // mensajes
import { UtilsService } from './helpers/utils.service'; // mensajes

import { AuthGuard } from './auth.guard';

import { MainService } from './components/main/main.service'; 
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
/* 
export function createTranslateLoader(http: Http) {
  return new TranslateStaticLoader(http, 'assets/i18n', '.json');
}
*/

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
}; 

@NgModule({
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		FlexLayoutModule,
		MaterialModule,
		RouterModule.forRoot(AppRoutes), 
      PerfectScrollbarModule,
      MenuToggleModule,	  
	  HttpClientModule,
	  NgSelectModule,
	  //HttpModule,
	  // TourNgBootstrapModule.forRoot(),
	  /*
      TranslateModule.forRoot({
		   provide: TranslateLoader,
		   useFactory: (createTranslateLoader),
		   deps: [Http]
		}),
		*/
	],
	declarations: [
		AppComponent, 
		MainComponent, 
		AuthComponent
	],
	bootstrap: [AppComponent],
	providers:[
		MenuItems,
		  // HorizontalMenuItems,
		AuthGuard,
		AuthenticationService,
		TokenService,
		MessageService,
		GeneralService,
		UtilsService,
		MainService,
		NgbActiveModal,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: Interceptor,
			multi: true,
		},
		PageTitleService,
      	{
        	provide: PERFECT_SCROLLBAR_CONFIG,
         	useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		}
	]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/app.module.ts